import JournalBlockForm from "../../../../views/dashboard/sale-page/page-blocks/forms/JournalBlockForm";
import HeroBlockForm from "../../../../views/dashboard/sale-page/page-blocks/forms/HeroBlockForm";
import ProductListBlockForm from "../../../../views/dashboard/sale-page/page-blocks/forms/ProductListBlockForm";
import TrustBlockForm from "../../../../views/dashboard/sale-page/page-blocks/forms/TrustBlockForm";
import FaqsBlockForm from "../../../../views/dashboard/sale-page/page-blocks/forms/FaqsBlockForm";
import ComplianceBarBlock from "../../models/blocks/ComplianceBarBlock";
import PageHeaderBlock from "../../models/blocks/PageHeaderBlock";
import LinkBlock from "../../models/blocks/LinkBlock";
import PageFooterBlock from "../../models/blocks/PageFooterBlock";
import FooterLinksBlock from "../../models/blocks/FooterLinksBlock";
import FooterBenefitsBlock from "../../models/blocks/FooterBenefitsBlock";
import AnnouncementBarBlock from "../../models/blocks/AnnouncementBarBlock";
export default {
  [AnnouncementBarBlock.NAME]: {
    default_announcement: {
      [ComplianceBarBlock.getTextAttributeName()]: '¡Envío gratis hoy!'
    }
  },
  [ComplianceBarBlock.NAME]: {
    default_compliance: {
      [ComplianceBarBlock.getTextAttributeName()]: 'Copyright © {from}-{to} {domain_name}. Todos los derechos reservados.'
    }
  },
  [PageHeaderBlock.NAME]: {
    default_header: {
      [PageHeaderBlock.getLinksAttributeName()]: [{
        [LinkBlock.getNameAttributeName()]: 'Home'
      }, {
        [LinkBlock.getNameAttributeName()]: 'Productos'
      }, {
        [LinkBlock.getNameAttributeName()]: 'Faq'
      }, {
        [LinkBlock.getNameAttributeName()]: 'Sobre Nosotros'
      }, {
        [LinkBlock.getNameAttributeName()]: 'Contacto'
      }]
    }
  },
  [PageFooterBlock.NAME]: {
    default_footer: {
      [PageFooterBlock.getSectionsAttributeName()]: [{}, {
        [FooterLinksBlock.getTitleAttributeName()]: 'Informationes',
        [FooterLinksBlock.getLinksAttributeName()]: [{
          [LinkBlock.getNameAttributeName()]: 'Envío y devolución'
        }, {
          [LinkBlock.getNameAttributeName()]: 'Faq'
        }, {
          [LinkBlock.getNameAttributeName()]: 'Sobre nosotros'
        }, {
          [LinkBlock.getNameAttributeName()]: 'Contacto'
        }]
      }, {
        [FooterLinksBlock.getTitleAttributeName()]: 'Legal pages ',
        [FooterLinksBlock.getLinksAttributeName()]: [{
          [LinkBlock.getNameAttributeName()]: 'Terms of Service'
        }, {
          [LinkBlock.getNameAttributeName()]: 'Privacy Policy'
        }, {
          [LinkBlock.getNameAttributeName()]: 'Refund Policy'
        }]
      }, {
        [FooterBenefitsBlock.getParagraphAttributeName()]: '<p><strong>Pago seguro</strong></p><p><strong>Envío gratuito y entrega rápida</strong><span><strong>( 5 a 8 días )</strong></span></p>'
      }]
    }
  },
  [HeroBlockForm.NAME]: {
    home: {
      text: '<p style="text-align: justify; padding: 0.1px" dir="ltr"><span style="font-size: 20pt; color: #FFFFFF">¡Increíble experiencia de compra en línea!</span></p><p style="text-align: justify; padding: 0.1px" dir="ltr"></p><ul dir="auto" style="padding-inline-start: 24px"><li style="color: #FFFFFF"><p dir="auto" style="padding: 0.1px"><span style="font-size: 18pt; color: #FFFFFF">Productos de alta calidad</span></p></li><li style="color: #FFFFFF"><p dir="auto" style="padding: 0.1px"><span style="font-size: 18pt; color: #FFFFFF">Descuentos increibles</span></p></li><li style="color: #FFFFFF"><p dir="auto" style="padding: 0.1px"><span style="font-size: 18pt; color: #FFFFFF">Entrega rápida</span></p><p dir="auto" style="padding: 0.1px"></p></li></ul><p dir="auto" style="padding: 0.1px"><span style="font-size: 20pt; color: #FFFFFF"> ¡No lo dudes! Te encantarán nuestros productos</span></p>',
      button_text: 'Descubre nuestros productos'
    }
  },
  [ProductListBlockForm.NAME]: {
    discover_products: {
      title: 'Descubre nuestros productos'
    }
  },
  [JournalBlockForm.NAME]: {
    amazing_delivery_experience: {
      title: 'Experiencia de entrega satisfactoria',
      paragraph: '<p style="text-align: justify; padding: 0.1px" dir="ltr">Puede realizar su pedido en nuestra tienda con tranquilidad, nos asociamos con los mejores mensajeros de {country_name} para brindarle un tiempo de entrega rápido de 5 a 8 días, y un método de pago seguro online, mediante tarjeta, o Contra Reembolso dependiendo del producto.</p>'
    },
    best_customer_service: {
      title: 'El mejor servicio al cliente',
      paragraph: '<p style="text-align: justify; padding: 0.1px" dir="auto">Nuestro equipo de atención al cliente está siempre aquí para responder a sus preguntas y ayudarle con su pedido, así como en el servicio postventa.Hacemos todo lo posible para responder a todos nuestros clientes en menos de 24 horas. Si tiene alguna pregunta, por favor contáctenos desde <a target="_blank" rel="noopener noreferrer nofollow" href="https://maxcomshop.com/contact"><strong>esta página</strong></a></p>'
    },
    about_us: {
      title: 'Sobre nosotros',
      paragraph: '<p dir="auto" style="padding: 0.1px">:domain_title es una tienda online en :country_name especializada en productos y complementos innovadores que harán tu día a día más fácil y divertido.Hacemos todo lo posible para brindar soporte de calidad y tiempos de envío más rápidos a nuestros clientes. Nos comprometemos a procesar sus pedidos en menos de 24 horas y a responder a todas sus preguntas a tiempo.Nos complace darle la bienvenida a nuestra tienda, no dude en realizar pedidos en cualquier momento :) Su satisfacción es nuestra prioridad.</p>'
    }
  },
  [TrustBlockForm.NAME]: {
    satisfaction_guarantee: {
      title: 'Garantía de satisfacción del 100%',
      paragraph: 'Ofrecemos envío gratuito en todos los productos y le damos 30 días de garantía, para probar tranquilamente su compra.',
      badges_list: [{
        text: 'Envío gratis'
      }, {
        text: 'Garantía de devolución'
      }, {
        text: 'Pago seguro'
      }, {
        text: 'Atención al cliente rápida'
      }]
    }
  },
  [FaqsBlockForm.NAME]: {
    home: {
      title: 'FAQ',
      other_questions_title: '¿Tienes otras preguntas?',
      other_questions_text: '<p style="color: #FFFFFF; text-align: center; padding: 0.1px" dir="ltr">Visite la página de contacto y envíenos su mensaje. Hacemos nuestro mejor esfuerzo para responder a todos nuestros clientes en menos de 24 horas.</p>',
      other_questions_button_text: 'Contacta con nosotras',
      faqs_list: [{
        title: '¿CÓMO PUEDO SEGUIR MIS PEDIDOS Y PAGOS?',
        text: '<p style="color: #FFFFFF; text-align: justify; padding: 0.1px" dir="ltr"><span>Le enviaremos el número de seguimiento por correo electrónico inmediatamente después de enviar su pedido.</span></p>'
      }, {
        title: '¿Y SI NECESITO DEVOLVER EL PRODUCTO?',
        text: '<p style="color: #FFFFFF; text-align: justify; padding: 0.1px" dir="ltr"><span>¡No se preocupe! Contáctanos lo antes posible en los primeros 7 días posteriores a la recepción de tu pedido y te ayudaremos a procesar la devolución y el reembolso o cambio.</span></p>'
      }, {
        title: '¿CUÁNTO TIEMPO TARDE EN RECIBIR MI PEDIDO?',
        text: '<p style="color: #FFFFFF; text-align: justify; padding: 0.1px" dir="ltr"><span>Su pedido se entregará dentro de los 5-8 días posteriores a la confirmación del pedido, dependiendo del volumen de pedidos recibidos. Si hay algún retraso en la recepción de su pedido, comuníquese con nosotros y lo ayudaremos a confirmar el estado de su pedido.</span></p>'
      }, {
        title: '¿QUÉ POSIBILIDADES DE PAGO ?',
        text: '<p style="color: #FFFFFF; text-align: justify; padding: 0.1px" dir="ltr"><span>Puedes pagar con tarjeta online, o Contra Reembolso dependiendo del producto. La transacción es 100% segura y no guardamos la información de su tarjeta.</span></p>'
      }, {
        title: '¿QUÉ PASA SI MI ENTREGA SE DAÑA O SE PIERDE?',
        text: '<p style="color: #FFFFFF; text-align: justify; padding: 0.1px" dir="ltr"><span>Nos tomamos estos problemas muy en serio y los trataremos caso por caso. Para obtener más información sobre nuestra política de cambio y reembolso, </span><a target="_blank" rel="noopener noreferrer nofollow" href="/shipping-return-policy"><span><strong>haga clic aquí</strong></span></a><span>.</span></p>'
      }]
    }
  }
};